import AdminText from './AdminText';
import React, { useEffect } from 'react';
import { apiUrl } from '../../config'
import { fetchData } from '../../utils/api';

import { boolElemByRole } from '../../utils/dynamic';
import { useAdminLanguage } from '../../AdminLanguageContext';
import { translateAdmin } from '../../utils/adminTranslations';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

const SidebarLink = ({ to, children, exact = false, badge }) => (
  <li>
    <NavLink
      to={to}
      end={exact}
      className={({ isActive }) => `system-sidebar__link${isActive ? ' is-active' : ''}`}
    >
      <span className="system-sidebar__link-marker" aria-hidden="true" />
      <span className="system-sidebar__link-label">{children}</span>
      {badge > 0 && <span className="system-sidebar__badge">{badge}</span>}
    </NavLink>
  </li>
);

function SideBar() {
  const { language, setLanguage } = useAdminLanguage();
  const translate = (text) => translateAdmin(text, language);
  const navigate = useNavigate()
  const [employeeName, setEmployeeName] = React.useState('');
  const handleLogout = () => {
    // Удаляем токен и другие данные из localStorage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('asd');

    // Перенаправляем пользователя на страницу входа
    navigate('/login');

    // Перезагружаем страницу
    window.location.reload();
  };

  const [newReviews, setNewReviews] = React.useState(0);

  const fetchCurrentUser = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetchData(`${apiUrl}/api/sys/current-user`, "GET", token);
      if (response.request.status === 0) {
        const { first_name, last_name, username } = response.request.data;
        setEmployeeName([first_name, last_name].filter(Boolean).join(' ') || username);
      } else {
        console.error("Ошибка загрузки имени сотрудника:", response.request.message);
      }
    } catch (error) {
      console.error("Ошибка загрузки имени сотрудника:", error);
    }
  };

  const checkReviews = async () => {
    try {

      const token = localStorage.getItem('accessToken');
      const response = await fetchData(`${apiUrl}/api/sys/check-reviews`, "GET", token)
      if (response.request.status)
        console.error("Ошибка загрузки данных:", response.request.message);
      else {
        setNewReviews(response.request.data);
      }
    } catch (err) { }
  };

  useEffect(() => {
    fetchCurrentUser();
    checkReviews();

    // Слушаем событие обновления
    window.addEventListener("reviewsUpdated", checkReviews);

    const interval = setInterval(checkReviews, 120000);

    return () => {
      clearInterval(interval);
      window.removeEventListener("reviewsUpdated", checkReviews);
    };
  }, []);

  return (
    <div className="system-sidebar">
      <div className="system-sidebar__brand">
        <span className="system-sidebar__brand-mark" aria-hidden="true">B</span>
        <span className="system-sidebar__brand-copy">
          <strong>Berkarar</strong>
          <small>{translate('Управление отелем')}</small>
          {employeeName && <span className="system-sidebar__employee">{employeeName}</span>}
        </span>
      </div>
      <nav className="system-sidebar__navigation" aria-label={translateAdmin("Основная навигация")}>
        {boolElemByRole(['admin', 'booker', 'booker-admin']) && (
          <>
            <section className="system-sidebar__section" aria-label={translate('Онлайн-брони')}>
              <h2 className="system-sidebar__section-title">{translate('Онлайн-брони')}</h2>
              <ul>
                <SidebarLink to="/system" exact>{translate('Активные')}</SidebarLink>
                <SidebarLink to="/system/expired-bookings">{translate('Не заселённые')}</SidebarLink>
                <SidebarLink to="/system/canceled-bookings">{translate('Отменённые')}</SidebarLink>
                <SidebarLink to="/system/canceled-bookings/refunded">{translate('Отменённые с возвратом')}</SidebarLink>
              </ul>
            </section>
            <section className="system-sidebar__section" aria-label={translate('Ручные брони')}>
              <h2 className="system-sidebar__section-title">{translate('Ручные брони')}</h2>
              <ul>
                <SidebarLink to="/system/off" exact>{translate('Активные')}</SidebarLink>
                <SidebarLink to="/system/off/expired-bookings">{translate('Не заселённые')}</SidebarLink>
                <SidebarLink to="/system/off/canceled-bookings">{translate('Отменённые')}</SidebarLink>
                <SidebarLink to="/system/off/canceled-bookings/refunded">{translate('Отменённые с возвратом')}</SidebarLink>
              </ul>
            </section>
          </>
        )}
        <section className="system-sidebar__section" aria-label={translate('Основное')}>
          <h2 className="system-sidebar__section-title">{translate('Основное')}</h2>
          <ul>
            {boolElemByRole(['admin', 'booker-admin']) && (
              <SidebarLink to="/system/users">{translate('Пользователи')}</SidebarLink>
            )}
            {boolElemByRole(['admin', 'booker-admin']) && (
              <SidebarLink to="/system/settings/online">{translate('Настройки сайта')}</SidebarLink>
            )}
            {boolElemByRole(['admin', 'booker', 'booker-admin']) && (
              <SidebarLink to="/system/customers">{translate('Клиенты')}</SidebarLink>
            )}
            {boolElemByRole(['admin', 'booker', 'booker-admin']) && (
              <>
                <SidebarLink to="/system/reviews" badge={newReviews}>{translate('Отзывы')}</SidebarLink>
                <SidebarLink to="/system/rooms">{translate('Номера')}</SidebarLink>
              </>
            )}
          </ul>
        </section>
      </nav>
      <div className="system-sidebar__footer">
        <label className="system-sidebar__language">
          <span>{translate('Язык')}</span>
          <select
            aria-label={translate('Язык')}
            value={language === 'tm' ? 'tm' : 'ru'}
            onChange={(event) => setLanguage(event.target.value)}
          >
            <option value="ru"><AdminText>Русский</AdminText></option>
            <option value="tm">Türkmençe</option>
          </select>
        </label>
        <button className="system-sidebar__logout" onClick={handleLogout}>
          <span aria-hidden="true">↪</span>
          {translate('Выйти из аккаунта')}
        </button>
      </div>
    </div>
  );
}

export default SideBar;
